import * as Types from './types';
import { actionTypes } from './constants';

export const setFormError = (error: string | undefined): Types.ISetFormError => ({
    type: actionTypes.SET_FORM_ERROR,
    payload: error
});

export const setIsExternalScriptLoaded = (isLoaded: boolean): Types.ISetIsExternalScriptLoaded => ({
    type: actionTypes.SET_IS_EXTERNAL_SCRIPT_LOADED,
    payload: isLoaded
});

export const setIsRecaptchaShown = (isShown: boolean): Types.ISetIsRecaptchaShown => ({
    type: actionTypes.SET_IS_RECAPTCHA_SHOWN,
    payload: isShown
});

export const setIsWaitingForBankIdConfirmation = (isInProgress: boolean): Types.ISetIsWaitingForBankIdConfirmation => ({
    type: actionTypes.SET_IS_WAITING_FOR_BANK_ID_CONFIRMATION,
    payload: isInProgress
});
